export default __webpack_public_path__ + "static/media/noku-logo.449b94a8.png";